
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1612d_oahif_43",
  "spinner-rotator": "awsui_spinner-rotator_1612d_oahif_1",
  "size-x-small": "awsui_size-x-small_1612d_oahif_58",
  "size-normal": "awsui_size-normal_1612d_oahif_65",
  "size-big": "awsui_size-big_1612d_oahif_72",
  "size-large": "awsui_size-large_1612d_oahif_79",
  "variant-normal": "awsui_variant-normal_1612d_oahif_86",
  "variant-disabled": "awsui_variant-disabled_1612d_oahif_89",
  "variant-inverted": "awsui_variant-inverted_1612d_oahif_92",
  "circle": "awsui_circle_1612d_oahif_104",
  "circle-left": "awsui_circle-left_1612d_oahif_132",
  "spinner-line-left": "awsui_spinner-line-left_1612d_oahif_1",
  "circle-right": "awsui_circle-right_1612d_oahif_137",
  "spinner-line-right": "awsui_spinner-line-right_1612d_oahif_1"
};
  